import { API_URL } from '@/config'
import axios from 'axios'
import app from '@/main'
import store from '@/store'

const HTTP = axios.create({ baseURL: API_URL })

const getAuthToken = () => localStorage.getItem('authtoken')

const showToast = (message, title = 'Error', variant = 'warning') => {
  app.$bvToast.toast(message, {
    title,
    autoHideDelay: 5000,
    variant,
    appendToast: false
  })
}

const getErrorMessage = (data) => 
  data?.violations?.[0]?.message || data?.['hydra:description'] || 'An error occurred'

// Request interceptor
HTTP.interceptors.request.use(
  (config) => {
    app.$Progress.start()
    store.commit('WORKING', true)
    const token = getAuthToken()
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.headers.Accept = 'application/ld+json'
    
    return config
  },
  (error) => {
    app.$Progress.fail()
    store.commit('WORKING', false)
    return Promise.reject(error)
  }
)

// Response interceptor
HTTP.interceptors.response.use(
  (response) => {
    app.$Progress.finish()
    store.commit('WORKING', false)
    return response
  },
  (err) => {
    app.$Progress.fail()
    store.commit('WORKING', false)
    
    const { response } = err
    
    if (!response) return Promise.reject(err)
    
    const { status, data, config } = response
    
    if (status === 401 && !config.__isRetryRequest) {
      showToast(data.message, 'Error')
      return app.$store.dispatch('logout').then(() => {
        if (app.$route.name !== 'login') {
          app.$router.push({ name: 'login' })
        }
        return Promise.reject(err)
      })
    }
    
    if (status === 400) {
      showToast(getErrorMessage(data))
    } else if (status === 404) {
      showToast('Resource not found', '404')
    }  else if (status < 500) {
      showToast(getErrorMessage(data))
    } else if (!config.__isRetryRequest) {
      config.__isRetryRequest = true
      return HTTP(config)
    } else {
      console.error(getErrorMessage(data))
    }
    
    return Promise.reject(err)
  }
)

export { HTTP }